//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GameMode, MAX_MULTIPLIERS, GameStatus, BetType } from './enum';

const MIN_BET_AMOUNT_USD = 0.25;
const STORAGE_KEY = 'chicken-road-amounts';

export default {
  name: 'BetCreatorRatiosComponent',
  props: {
    // 当前游戏对象
    currentGame: {
      type: Object,
      default: null
    },
    // 主账号余额
    balanceUsd: {
      type: Number,
      default: 0
    },
    // 赠送/打码余额
    wagerBalanceUsd: {
      type: Number,
      default: 0
    },
    // 当前全局设置的下注金额
    betAmountUsd: {
      type: Number,
      default: 0.25
    },
    // 主播模式标记
    isStreamerMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fastAmounts: [1, 2, 5, 10],
      editableAmounts: [1, 2, 5, 10],
      selectedFastBet: null, // number | 'max' | null
      editorOpened: false,
      isLg: false,
      debounceTimer: null
    };
  },
  computed: {
    // 游戏进行中禁用下注金额调整
    disabled() {
      return this.currentGame && this.currentGame.status === GameStatus.IN_PROGRESS;
    },

    // 当前下注金额
    currentBetAmount() {
      return this.betAmountUsd;
    },

    // 判断是否是全仓/最大下注
    isMaxBet() {
      const maxBalance = Number(this.balanceUsd) + Number(this.wagerBalanceUsd);
      if (!maxBalance) return false;

      return Math.abs(this.currentBetAmount - maxBalance) < 0.01;
    }
  },
  watch: {
    fastAmounts: {
      deep: true,
      handler(newVal) {
        this.saveToLocalStorage();
      }
    }
  },
  mounted() {
    this.checkIsLg();
    window.addEventListener('resize', this.handleResize);

    // 读取 localStorage 缓存的快捷金额配置
    this.loadFromLocalStorage();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
  methods: {
    handleResize() {
      this.checkIsLg();
    },

    checkIsLg() {
      this.isLg = window.innerWidth <= 1024;
    },

    setFastAmount(amount) {
      if (this.disabled) return;

      if (amount === 'max') {
        const maxBalance = Number(this.balanceUsd) + Number(this.wagerBalanceUsd);
        this.$emit('update:betAmountUsd', maxBalance);
        this.selectedFastBet = 'max';
      } else {
        this.$emit('update:betAmountUsd', amount);
        this.selectedFastBet = amount;
      }
    },

    isAmountSelected(amount) {
      return Math.abs(this.currentBetAmount - amount) < 0.01;
    },

    onBetAmountInput(event) {
      if (this.disabled) return;

      const value = parseFloat(event.target.value);

      if (!isNaN(value) && value > 0) {
        this.$emit('update:betAmountUsd', value);
        this.selectedFastBet = null;
      } else if (event.target.value === '' || isNaN(value)) {
        this.$emit('update:betAmountUsd', 0);
        this.selectedFastBet = null;
      }
    },

    onBetAmountBlur() {
      if (this.currentBetAmount < MIN_BET_AMOUNT_USD) {
        this.$emit('update:betAmountUsd', MIN_BET_AMOUNT_USD);
        this.selectedFastBet = null;
      }
    },

    toggleEditor() {
      this.editorOpened = !this.editorOpened;

      if (this.editorOpened) {
        this.editableAmounts = [...this.fastAmounts];
      }
    },

    isAmountInvalid(val) {
      return val === null || val === undefined || val < 0.01 || val > 9999;
    },

    onEditableAmountInput() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      // 防抖处理编辑器数组变更 (相当于 Angular 里的 debounceTime(150))
      this.debounceTimer = setTimeout(() => {
        const isValid = this.editableAmounts.every(val => !this.isAmountInvalid(val));

        if (isValid) {
          this.fastAmounts = [...this.editableAmounts];
        }
      }, 150);
    },

    loadFromLocalStorage() {
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
          const parsed = JSON.parse(saved);
          if (Array.isArray(parsed.fastAmounts) && parsed.fastAmounts.length === 4) {
            this.fastAmounts = parsed.fastAmounts;
            this.editableAmounts = [...parsed.fastAmounts];
          }
        }
      } catch (e) {
        // 静默处理 JSON 解析错误
      }
    },

    saveToLocalStorage() {
      try {
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            fastAmounts: this.fastAmounts,
            selectedFastBet: this.selectedFastBet
          })
        );
      } catch (e) {
        // 忽略 localStorage 写入异常
      }
    }
  }
};
